module.exports = __webpack_public_path__ + "static/media/close.793c7629.svg";